// @ts-check

/**
 * @typedef {import('./tenant_configuration_editor_types').TenantConfigurationEditorInstance} TenantConfigurationEditorInstance
 * @typedef {import('./tenant_configuration_editor_types').ProjectUpdatePayload} ProjectUpdatePayload
 * @typedef {import('./tenant_configuration_editor_types').ContactUpdatePayload} ContactUpdatePayload
 */

/** @param {TenantConfigurationEditorInstance} editor @returns {{first_name: string, last_name: string}} */
export function split_name(editor) {
  const parts = String(editor.form.primary_contact || '').trim().split(/\s+/).filter(Boolean);
  return name_payload(parts);
}

function name_payload(parts = []) {
  const payload = Object.fromEntries([]);
  payload.first_name = parts.slice(0, -1).join(' ');
  payload.last_name = parts.slice(-1).join('');
  return payload;
}

/** @param {TenantConfigurationEditorInstance} editor @returns {ProjectUpdatePayload} */
export function build_project_update_payload(editor) {
  const payload = Object.fromEntries([]);
  payload.project_id = editor.selected_project_id;
  payload.project_name = editor.form.organisation_name.trim();
  payload.project_description = `Sector: ${editor.form.sector.trim()}`;
  payload.project_type_id = Number(editor.selected_project?.project_type?.id);
  payload.enable_compliance_task = Boolean(editor.selected_project?.enable_compliance_task);
  return payload;
}

/**
 * @param {TenantConfigurationEditorInstance} editor
 * @param {{first_name: string, last_name: string}} name
 * @returns {ContactUpdatePayload|null}
 */
export function build_contact_update_payload(editor, name) {
  if (!editor.contact_user_id || !name.first_name || !name.last_name || !editor.contact_role_id) {
    return null;
  }

  const payload = Object.fromEntries([]);
  payload.user_id = editor.contact_user_id;
  payload.first_name = name.first_name;
  payload.last_name = name.last_name;
  payload.email = editor.form.primary_email.trim();
  payload.phone_number = editor.form.primary_phone.trim();
  payload.role_id = editor.contact_role_id;
  return payload;
}
